import { render, staticRenderFns } from "./PendingNotificationsBanner.vue?vue&type=template&id=b90e9e50&scoped=true"
import script from "./PendingNotificationsBanner.vue?vue&type=script&lang=js"
export * from "./PendingNotificationsBanner.vue?vue&type=script&lang=js"
import style0 from "./PendingNotificationsBanner.vue?vue&type=style&index=0&id=b90e9e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90e9e50",
  null
  
)

export default component.exports